// collapsible-panel.js

export default class CollapsiblePanel {
  constructor(selector) {
    this.$ = window.jQuery;
    this.$panels = this.$(selector);

    this.init();
  }

  init() {
    this.$panels.each((index, panel) => {
      const $panel = this.$(panel);
      const $header = $panel.find(".collapsible-panel__header");
      const $content = $panel.find(".collapsible-panel__content");

      $header.on("click", () => {
        $panel.toggleClass("is-open");
        $content.toggleClass("is-open");
      });
    });
  }
}
